export const LIST_CUSTOMER_PAYMENT_METHODS = 'stripe/listCustomerPaymentMethods';
export const DELETE_CUSTOMER_PAYMENT_METHOD = 'stripe/deleteCustomerPaymentMethod';
export const BUY_PRODUCTS = 'stripe/buyProducts';
export const UPDATE_CUSTOMER_PAYMENT_METHOD = 'stripe/updateCustomerPaymentMethod';
export const LIST_CUSTOMER_INVOICES = 'stripe/listCustomerInvoices';

export const LIST_FREE_EXAM = 'exams/listFreeExams';
export const GET_FREE_USER_EXAM = 'exams/getFreeUserExam';
export const CREATE_FREE_USER_EXAM = 'exams/createFreeUserExam';
export const UPDATE_FREE_USER_EXAM = 'exams/updateFreeUserExam';
export const ADD_COURSE_EXAM_FREE = 'exams/addCourseExamFree';
